var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgLinePrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 324,
    viewBox: "0 0 375 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-104 120.137C-104 120.137 -8.32266 230.619 104.668 244.091C236.834 259.849 382.545 223.322 406.411 144.512C425.182 82.529 386.895 -4.11417 281.811 1.23635C207.909 4.99918 173.57 64.6358 176.226 106.166C186 259 461 323 461 323",
    stroke: "#3CB4E5",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-104 120.137C-104 120.137 -8.32266 230.619 104.668 244.091C236.834 259.849 382.545 223.322 406.411 144.512C425.182 82.529 386.895 -4.11417 281.811 1.23635C207.909 4.99918 173.57 64.6358 176.226 106.166C186 259 461 323 461 323",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLinePrimary);
export default __webpack_public_path__ + "static/media/bg-line-primary.8f17563924f565ea78fa5222cfc347b7.svg";
export { ForwardRef as ReactComponent };